import Actions from 'actions';

const initialState = Object.freeze({});

function unfavourite(state = initialState, action) {
  switch (action.type) {
    case Actions.UNFAVOURITE_ARTICLE_INFO_REQUEST:
      return initialState;
    case Actions.UNFAVOURITE_ARTICLE_INFO_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.UNFAVOURITE_ARTICLE_INFO_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default unfavourite;
